import React from "react";
import PropTypes from "prop-types";
import { List } from "@mui/material";
import SubMenuList from "./SubMenuList";
import MobileSubMenuList from "./MobileSubMenuList";

const VerticalLayoutMenu = ({
  menuItem,
  isDrawerOpen,
  isTooltipComponent = false,
}) => {
  return (
    <List
      sx={{ width: "100%", maxWidth: 360 }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {menuItem?.length
        ? menuItem?.map((item, index) =>
            isDrawerOpen ? (
              <SubMenuList
                subList={item}
                key={item.name + index}
                isDrawerOpen={isDrawerOpen}
              />
            ) : (
              <MobileSubMenuList
                subList={item}
                key={item.name + index}
                isDrawerOpen={false}
                isTooltipComponent={isTooltipComponent}
              />
            )
          )
        : null}
    </List>
  );
};

export default VerticalLayoutMenu;

VerticalLayoutMenu.propTypes = {
  menuItem: PropTypes.array,
  isDrawerOpen: PropTypes.bool,
  isTooltipComponent: PropTypes.bool,
};
